import firebase from "firebase";

const firebaseConfig = {
    apiKey: "AIzaSyBKIy7uP03KUiqermCUZwwm0NuTUuLKM9k",
    authDomain: "cadride-1c192.firebaseapp.com",
    projectId: "cadride-1c192",
    storageBucket: "cadride-1c192.firebasestorage.app",
    messagingSenderId: "1071967116594",
    appId: "1:1071967116594:android:28da65cd2472bd5d920b2b"
};

if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
}

const db = firebase.firestore();
const auth = firebase.auth();
const store = firebase.storage();

export { db, auth, store };